import placeholder_poster from '../../assets/images/tile-placeholder-poster.png';
import placeholder_backdrop from '../../assets/images/tile-placeholder-backdrop.png';
import DevelopmentEnvironment from './environment/_development';
import TestingEnvironment from './environment/_testing';
import StagingEnvironment from './environment/_staging';
import IntegrationEnvironment from './environment/_integration';
import PreProdEnvironment from './environment/_preprod';
import ProductionEnvironment from './environment/_production';

const environmentMap = {
    development: DevelopmentEnvironment,
    testing: TestingEnvironment,
    staging: StagingEnvironment,
    integration: IntegrationEnvironment,
    preprod: PreProdEnvironment,
    production: ProductionEnvironment,
};

const runtimeEnvironment = (process.env.ENVIRONMENT || process.env.NODE_ENV || 'development').toLowerCase();
const selectedEnvironment = environmentMap[runtimeEnvironment] || DevelopmentEnvironment;

const getEnvironmentValue = (key, fallback = undefined) => {
    if (typeof process.env[key] !== 'undefined') {
        return process.env[key];
    }
    if (typeof selectedEnvironment[key] !== 'undefined') {
        return selectedEnvironment[key];
    }
    return fallback;
};

/**
 * App config
 */
export default {
    // General
    VERSION: process.env.VERSION,
    BUILD: process.env.BUILD,
    ENVIRONMENT: getEnvironmentValue('ENVIRONMENT', runtimeEnvironment),
    ROOT: '/',
    BASE_URL: getEnvironmentValue('BASE_URL'),
    LOCALE: 'en',
    SHOW_LOGGER_MSGS: process.env.SHOW_LOGGER_MSGS && process.env.SHOW_LOGGER_MSGS === 'true',
    PLACEHOLDER_IMAGE_POSTER: placeholder_poster,
    PLACEHOLDER_IMAGE_BACKDROP: placeholder_backdrop,
    PLACEHOLDER_IMAGE_BACKGROUND: placeholder_backdrop,
    PLACEHOLDER_IMAGE_TRAILER: placeholder_backdrop,
    START_YEAR: 2018,
    NUMBER_OF_YEARS: 11,
    SEARCH_RESULTS_LIMIT: 21,
    STOREFRONT_INITIAL_PAGE_ROWS_COUNT: 6,
    STOREFRONT_PAGE_ROWS_BATCH_COUNT: 3,
    STOREFRONT_GENRE_PAGE_ROW_MEDIA_LIMIT: 30,
    MEDIA_CAROUSEL_TALLY_MAX_ITEMS: 24,
    DEFAULT_DEVICE_TYPE: 'WindowsOnX86',
    USE_DEFAULT_DEVICE_TYPE: false,
    VUBIQUITY_ANALYTICS_ENABLED: true,
    REGISTERED_DEVICE_LIMIT: 5,
    MEDIA_PLAYER_VOLUME: 75,
    MEDIA_PLAYER_CONTROLS_AUTO_HIDE: 5500,
    MAIN_NAVIGATION_SECTIONS: [
        {
            settingKey: 'MoviePageRowOrder', classification: 'movie',
            excludedPromotions: ['COLLECTIONS_MOVIE']
        },
        {
            settingKey: 'TVPageRowOrder', classification: 'series',
            excludedPromotions: ['COLLECTIONS_TV']
        },
        {
            settingKey: 'StorefrontPageRowOrder', classification: null,
            excludedPromotions: ['COLLECTIONS_STOREFRONT', 'FEATURED_STOREFRONT', 'RECOMMENDATIONS_STOREFRONT'],
            importPromotionCollections: ['COLLECTIONS_STOREFRONT'],
            displayGenres: false
        }
    ],
    STOREFRONT_SETTING_KEY: 'StorefrontPageRowOrder',
    RAKUTEN_TV_WEB_URL: getEnvironmentValue('STOREFRONT_RAKUTEN_TV_WEB_URL', 'https://www.rakuten.tv/'),
    MEDIA_PLAYER_TYPE: 'shaka',
    MEDIA_PLAYER_TRAILER_TYPE: 'shaka',
    SHAKA_MEDIA_PLAYER_VERSION: '4.7.8',

    // API
    PROXY_API_URL: getEnvironmentValue('PROXY_API_URL'),
    VUB_API_URL: getEnvironmentValue('VUB_API_URL'),
    VUB_LOGWATCH_URL: getEnvironmentValue('VUB_LOGWATCH_URL'),
    VUB_LICENSOR_URL: getEnvironmentValue('VUB_LICENSOR_URL'),
    STRIPE_API_URL: 'https://api.stripe.com',
    STRIPE_V3_SDK: '', // TODO
    VUBIQUITY_DEVICE_FINGERPRINT_LIBRARY: 'https://vucscdnprodne.azureedge.net/scripts/content_services/device_management/vudevicefp-debug.js',
    STRIPE_USE_V3: true,

    // Identity
    APP_SETTINGS_GROUP: 'Clients-Web',
    STRIPE_API_PK: getEnvironmentValue('STRIPE_API_PK'),
    GA_TRACKING_ID: getEnvironmentValue('GA_TRACKING_ID'),
    GOOGLE_PLAY_STORE_APP_URL: 'https://play.google.com/store/apps/details?id=com.virginmedia.vmstore',
    APPLE_STORE_APP_URL: 'https://itunes.apple.com/gb/developer/virgin-media/id449156077',
    RE_CAPTCHA_SITE_KEY: getEnvironmentValue('RE_CAPTCHA_SITE_KEY'),
    IDENTITY_SECURITY_KEY: getEnvironmentValue('IDENTITY_SECURITY_KEY'),
    IMAGE_OPTIMISATION_LEVEL: '?q=80',
    ID: 'spoiledmilk.web.virginmedia',
    AFFILIATE_ID: 12,
    AFFILIATE_NAME: 'VirginMedia',
    TRUSTED_APPLICATION_TOKEN: btoa('2itAxeJVTy'),
    TRUSTED_APPLICATION_NAME: 'VirginMediaWebSite',
    CUSTOMER_SUPPORT_EMAIL: 'customerservice@virginmediastore.com',
    CUSTOMER_SUPPORT_TELEPHONE: '0800 027 0801',

    // get uk address api
    GET_ADDRESS_IO_URL: getEnvironmentValue('GET_ADDRESS_IO_URL'),
    GET_ADDRESS_IO_API_KEY: getEnvironmentValue('GET_ADDRESS_IO_API_KEY'),

    // VISION 360 API
    VISION360_API_URL: getEnvironmentValue('VISION360_API_URL'),
    VISION360_AUTH_KEY: getEnvironmentValue('VISION360_AUTH_KEY'),

    // Migration
    VUB_MIGRATION_URL: getEnvironmentValue('VUB_MIGRATION_URL'),

    //tile popup bubble debug
    // development variable is added for debugging in order to not remove popup element from DOM
    TILE_POPUP_BUBBLE_DEBUG_ENABLED: getEnvironmentValue('TILE_POPUP_BUBBLE_DEBUG_ENABLED') === 'true'
        || getEnvironmentValue('TILE_POPUP_BUBBLE_DEBUG_ENABLED') === true,
};
